<template>
    <v-dialog v-model="isActive" width="600" transition="dialog-bottom-transition">
        <v-card>
            <v-progress-linear v-if="loading" indeterminate height="5" color="orange"></v-progress-linear>
            <v-card-title class="headline justify-center">Eliminar {{ tipo }}</v-card-title>
            <div class="d-flex justify-center">
                <v-icon color="red" size="120">mdi-delete-alert-outline</v-icon>
            </div>
            <v-card-text v-if="tipo === 'telefono'" class="text-center text-subtitle-1 d-flex justify-center">
                ¿Estás suguro que desea eliminar el telefono ({{ itemSelected.carac }}) - {{ itemSelected.telefono }}?
            </v-card-text>
            <v-card-text v-if="tipo === 'email'" class="text-center text-subtitle-1 d-flex justify-center">
                ¿Estás suguro que desea eliminar la dirección {{ itemSelected.email }}?
            </v-card-text>
            <v-card-text v-if="tipo === 'domicilio'" class="text-center text-subtitle-1 d-flex justify-center">
                ¿Estás suguro que desea eliminar el domicilio {{ itemSelected.calle }} {{ itemSelected.nro }}?
            </v-card-text>
            <v-card-text v-if="tipo === 'familiar'" class="text-center text-subtitle-1 d-flex justify-center">
                ¿Estás suguro que desea eliminar a {{ itemSelected.apellido }}, {{ itemSelected.nombres }}, ?
            </v-card-text>
            <v-card-actions>
                <v-col cols="12">
                    <v-btn block @click="eliminar(true)" dark elevation="0" class="pa-5" color="red">
                        Eliminar
                    </v-btn>
                    <v-btn block @click="cerrar()" text color="red" elevation="0" class="mt-1 pa-5">
                        Cancelar
                    </v-btn>
                </v-col>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
export default {
    data() {
        return {
            isActive: false,
            callback: null,
        }
    },
    methods: {
        ...mapActions(['sendTelefono', 'sendDomicilio', 'sendEmail', 'sendFamiliar']),
        ...mapActions('dataUser', ['modificarFamiliar']),

        lanzar() {
            this.isActive = true
            return new Promise(resolve => {
                this.callback = resolve
            })
        },
        cerrar() {
            this.isActive = false
        },

        //nuevo metodo con callback
        eliminar(result) {
            if (this.callback) {
                this.callback(result)
                this.callback = null
            }
            this.isActive = false
        }
    },
    computed: {
        ...mapGetters('notificaciones', ['loading']),
        ...mapGetters('itemEdit', ['itemSelected', 'indiceSelected']),
    },
    props: ['accion', 'tipo']
}

</script>